import { routeHead } from "@/lib/routeHead";
import { META_DESCRIPTIONS } from "@/lib/metaDescriptions";
import { createFileRoute } from "@tanstack/react-router";
import Blog from "@/pages/Blog";
import { fetchBlogList, blogPreloadLinks } from "@/lib/blogList";

export const Route = createFileRoute("/pl/blog/")({
  loader: () => fetchBlogList(),
  head: ({ loaderData }) => ({ ...routeHead('Blog AGAPE — AI, sprzedaż i operacje', META_DESCRIPTIONS.blog.pl, '/pl/blog'), links: blogPreloadLinks(loaderData) }),
  component: BlogRoute,
});

function BlogRoute() {
  const { posts, categories } = Route.useLoaderData();
  return <Blog posts={posts} categories={categories} />;
}
